import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import DrugStoreAddComponent from 'src/components/views/DrugStore/DrugStoreAddPage';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';

const mapStateToProps = ({ userState: { isAgent, userInfo, isDomestic }, locationState: { locations } }: IStoreState) => ({
  isAgent,
  userInfo,
  locations,
  isDomestic,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrugStoreAddComponent);



// WEBPACK FOOTER //
// ./src/containers/DrugStoreAdd.ts